module.exports = __webpack_public_path__ + "img/042.77eb4418.jpg";